import { signal } from '@preact/signals-react';

/**
 * So thao tac sua lich do CHINH may nay thuc hien va chua chay xong.
 *
 * Dung de handler socket biet luc nao nen dung yen. Server broadcast ngay khi
 * commit, thuong toi truoc ca response cua request dat lich, nen handler doc duoc
 * ngay dang xem CU va tai lai ngay do. Response ay bi vut bo vi ngay da doi, roi
 * con keo theo mot lan hoi lai — hai vong request khong dung vao viec gi. Ban than
 * luong dat lich da tu tai lai dung ngay vua dat.
 *
 * Dem chu khong dung co: hai thao tac chong nhau thi thao tac xong truoc khong
 * duoc mo cong som cho thao tac con lai.
 *
 * Danh doi da biet: mot thay doi tu may khac roi dung vao khoang nay se khong duoc
 * tai theo su kien do. No van len o su kien ke tiep hoac lan doi ngay ke tiep.
 */
const inFlightCount = signal<number>(0);

export const beginLocalCalendarMutation = () => {
  inFlightCount.value += 1;
};

export const endLocalCalendarMutation = () => {
  // Khong cho xuong am: mot lan `end` thua se lam cong mo som o thao tac sau.
  inFlightCount.value = Math.max(0, inFlightCount.value - 1);
};

export const isLocalCalendarMutationInFlight = () => inFlightCount.value > 0;

/** Chi dung cho test, de moi truong hop bat dau tu trang thai sach. */
export const resetLocalCalendarMutation = () => {
  inFlightCount.value = 0;
};
